export default __webpack_public_path__ + "static/media/poll_delete_icon.b685234c.svg";